import { ITest, IQuestion } from '../data/interfaces';

export default class Test implements ITest {
  language = [];

  history = [];

  law = [];

  getQuestions(category: string): IQuestion[] {
    let questions: IQuestion[];
    switch (category) {
      case 'language':
        questions = this[category];
        break;
      case 'history':
        questions = this[category];
        break;
      case 'law':
        questions = this[category];
        break;
      default:
        questions = [];
    }
    return questions;
  }
}
